import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  INPUT_NAME: `${cleanedFilename(__filename)}-input-name`,
  INPUT_KEY: `${cleanedFilename(__filename)}-input-key`,
  DELETE_FIELD_BUTTON: `${cleanedFilename(__filename)}-delete-field-button`,
  CHECKBOX_DEFAULT: `${cleanedFilename(__filename)}-checkbox-default`,
  INPUT_DEFAULT_STRING: `${cleanedFilename(__filename)}-input-default-string`,
  INPUT_DEFAULT_NUMBER: `${cleanedFilename(__filename)}-input-default-number`,
  INPUT_DEFAULT_BOOLEAN: `${cleanedFilename(__filename)}-input-default-boolean`,
};
